module.exports = __webpack_public_path__ + "img/course.973da84c.jpg";